// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"ea868f64","508":"aa9d895c","875":"b37fad64"}[chunkId] + ".chunk.js";
};